// extracted by mini-css-extract-plugin
export default {"root":"style_root__tHpfJ","picture":"style_picture__6xIyb"};